/** Format phone number as XXX-XXX-XXXX while typing (no +1 prefix — shown as input group addon) */
export const formatPhoneInput = (value: string): string => {
  const cleanValue = value.replace(/^\+1\s*/, "");
  let digits = cleanValue.replace(/\D/g, "");
  if (digits.startsWith("1") && digits.length > 1) {
    digits = digits.slice(1);
  }
  digits = digits.slice(0, 10);
  if (digits.length === 0) return "";
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
};

/** Format raw 10-digit number for display as +1 XXX-XXX-XXXX */
export const formatPhoneDisplay = (digits: string): string => {
  if (digits.length !== 10) return digits;
  return `+1 ${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
};

/** Extract 10 digits from formatted phone (strips +1 or 1 prefix) */
export const extractDigits = (phone: string): string => {
  let digits = phone.replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) {
    digits = digits.slice(1);
  }
  return digits.slice(0, 10);
};

/** Check if phone has 10 valid digits */
export const isValidPhoneNumber = (phone: string): boolean => {
  return extractDigits(phone).length === 10;
};
